import React from "react";
import { formatToTwoDecimal } from "../../../../../utils/numberFormatter";

function RawMaterialTab({ rawMaterialTab, totalRawProduced, totalRawCosting }) {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm mb-3">
          <div className="w-100 d-flex align-items-center mt-3 mb-3">
            <h5>Production Details of Raw Materials</h5>
            <hr className="flex-grow-1 mx-3" />
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="thead-light">
                <tr>
                  <th>Product Code</th>
                  <th>Raw Materials Name</th>
                  <th>Processed QTY</th>
                  <th>Average Unit Price</th>
                  <th>Total Costing / Raw Materials</th>
                </tr>
              </thead>
              <tbody>
                {rawMaterialTab.map((data) => (
                  <tr key={data.product_id}>
                    {/* Product Code */}
                    <td>{data.product_list.product_code}</td>
                    {/* Raw Materials Name */}
                    <td>{data.product_list.product_name}</td>
                    {/* Processing Unit */}
                    <td>{formatToTwoDecimal(data.totalWeight)}</td>
                    {/* Average Unit Price */}
                    <td>{formatToTwoDecimal(data.averageUnitPrice)}</td>
                    {/* Total Costing / Raw Materials */}
                    <td>{formatToTwoDecimal(data.totalCosting)}</td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr className="font-weight-bold table-primary">
                  <td colspan="2" className="text-right fw-bold">
                    Total Processing Unit:
                  </td>
                  <td className="text-success fw-bold">
                    {formatToTwoDecimal(totalRawProduced)}
                  </td>
                  <td></td>
                  <td className="text-success fw-bold">
                    {formatToTwoDecimal(totalRawCosting)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RawMaterialTab;
